// extracted by mini-css-extract-plugin
export default {"List":"DesignTab_List__EoNA+"};